"use client";

import type { TextColor } from "@homeinstead/schemas";
import type { FranchiseInquiryFormInput } from "./franchiseInquiry.schema";

import { useFormContext } from "react-hook-form";
import {
  InquiryStepHeading,
  InquirySubmitButton,
  InquiryTextField,
  inquiryFormErrorTextClass,
  useInquiryFieldError,
} from "~www/components/LeadForm/Inquiry";
import { FranchiseInquiryMarketingOptIn } from "./FranchiseInquiryMarketingOptIn";

type FranchiseInquiryContactStepProps = {
  isPending: boolean;
  submitError?: string;
  textColor?: TextColor;
};

function FranchiseInquiryContactStep({
  isPending,
  submitError,
  textColor,
}: FranchiseInquiryContactStepProps) {
  const { register } = useFormContext<FranchiseInquiryFormInput>();
  const { errors, shouldShowError } =
    useInquiryFieldError<FranchiseInquiryFormInput>();
  const errorColorClass = inquiryFormErrorTextClass(textColor);

  return (
    <div className="flex w-full max-w-[440px] flex-col gap-4">
      <InquiryStepHeading textColor={textColor}>
        Tell us how to reach you
      </InquiryStepHeading>

      <div className="mb-2 flex flex-col gap-6">
        <InquiryTextField
          error={errors.firstName}
          errorClassName={errorColorClass}
          placeholder="First Name"
          showError={shouldShowError("firstName")}
          type="text"
          {...register("firstName")}
        />
        <InquiryTextField
          error={errors.lastName}
          errorClassName={errorColorClass}
          placeholder="Last Name"
          showError={shouldShowError("lastName")}
          type="text"
          {...register("lastName")}
        />
        <InquiryTextField
          error={errors.email}
          errorClassName={errorColorClass}
          placeholder="Email Address"
          showError={shouldShowError("email")}
          type="email"
          {...register("email")}
        />
        <InquiryTextField
          error={errors.phone}
          errorClassName={errorColorClass}
          placeholder="Phone Number"
          showError={shouldShowError("phone")}
          type="tel"
          {...register("phone")}
        />
      </div>

      <FranchiseInquiryMarketingOptIn textColor={textColor} />

      {!submitError ? null : (
        <p className={errorColorClass} role="alert">
          {submitError}
        </p>
      )}

      <InquirySubmitButton isPending={isPending} label="Enquire Now" />
    </div>
  );
}

export { FranchiseInquiryContactStep };
